<template>
    <SoliAvatarBtn
        v-if="student"
        @click="$emit('input', student)"
        :title="student.name"
        :subtitleBottom="student.email ?? null"
        :avatar="student.profile_photo_url"
        blue
    >
        <template>
            <div v-if="hasPaymentMethod" class="flex justify-start">
                <v-icon small>credit_card</v-icon
                >{{ `****${student.pm_last_four}` }}
            </div>
        </template>
    </SoliAvatarBtn>
</template>

<script>
export default {
    props: {
        student: {
            type: Object,
            default: () => {},
        },
        hasPaymentMethod: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style></style>
